<template>
  <van-popup
    closeable
    round
    :close-on-click-overlay="false"
    @close="closeHandle"
    v-model="IModalSwitch"
    :style="topImg ? {overflowY: 'visible'} : {}">
    <img v-if="topImg" class="top_img" src="./img/h5_coupon_punch_img_yhq@2x.png" srcset="./img/h5_coupon_punch_img_yhq.png 1x, ./img/h5_coupon_punch_img_yhq@2x.png 2x" >
    <div class="i_get_cool_modal">
      <h3 class="title" v-if="title">{{title}}</h3>
      <slot/>
      <div class="btns_wrap" :style="btnWrapStyle">
        <IButton type="shell"
                 v-if="cancel"
                 height="5"
                 @click.native.stop="cancelHandle"
                 :size="cancenSize"
                 :text="cancelTxt"/>
        <IButton class="query_btn" :style="queryStyle"
                 height="5"
                 @click.native.stop="queryHandle"
                 :size="querySize"
                 :text="queryTxt"/>
      </div>
      <slot name="footer"/>
    </div>
  </van-popup>
</template>

<script>
import { IButton } from '@/components/IButton';

export default {
  name: 'resModal',
  props: {
    show: Boolean,
    title: String,
    cancelTxt: {
      type: String,
      default: '取消'
    },
    queryTxt: {
      type: String,
      default: '确认'
    },
    cancel: {
      type: Boolean,
      default: true
    },
    column: Boolean,
    topImg: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      IModalSwitch: false
    };
  },
  computed: {
    querySize() {
      return this.column ? 'large' : this.cancel ? 'small' : 'large';
    },
    cancenSize() {
      return this.column ? 'large' : 'small';
    },
    queryStyle() {
      return this.column && this.cancel;
    },
    btnWrapStyle() {
      const styleOpt = {};
      styleOpt.flexDirection = this.column ? 'column' : 'row';
      !this.column && this.cancel && (styleOpt.margin = '20px -10px 0');
      this.column && this.cancel && (styleOpt.height = '1.1rem');
      return styleOpt;
    }
  },
  watch: {
    show(a) {
      this.IModalSwitch = a;
    }
  },
  created() {
    this.IModalSwitch = this.show;
  },
  methods: {
    queryHandle() {
      this.$emit('query');
    },
    closeHandle() {
      this.$emit('update:show', false);
    },
    cancelHandle() {
      this.$emit('cancel');
    }
  },
  components: {
    IButton
  }
};
</script>

<style scoped lang="stylus">
.top_img {
  margin-top -65px
}
.i_get_cool_modal {
  position resolution
  box-sizing border-box
  width 295px
  padding 30px 30px
  border-radius 16px
  background-color #ffffff

  .title {
    line-height 24px
    font-size 20px
    color #41414D
    text-align center
    font-weight 500
    margin-bottom 6px
  }

  .btns_wrap {
    display flex
    justify-content space-between
    margin-top 20px
  }
}
</style>
